import React from 'react';
import { ChevronDown } from 'lucide-react';

interface ProductSortProps {
  sortOption: string;
  onSortChange: (option: string) => void;
  productCount: number;
  currentCategory?: string;
  currentSubcategory?: string;
}

const ProductSort: React.FC<ProductSortProps> = ({
  sortOption,
  onSortChange,
  productCount,
  currentCategory,
  currentSubcategory,
}) => {
  const sortOptions = [
    { value: 'featured', label: 'Featured' },
    { value: 'newest', label: 'Newest First' },
    { value: 'price-asc', label: 'Price: Low to High' },
    { value: 'price-desc', label: 'Price: High to Low' },
    { value: 'rating', label: 'Highest Rated' },
    { value: 'name-asc', label: 'Name: A to Z' },
    { value: 'name-desc', label: 'Name: Z to A' },
  ];

  const getDisplayText = () => {
    if (currentSubcategory) {
      return `in ${currentSubcategory.replace(/-/g, ' ')}`;
    }
    if (currentCategory) {
      return `in ${currentCategory}`;
    }
    return '';
  };

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6 p-4 bg-white rounded-lg border border-gray-200">
      <div className="flex items-center space-x-4">
        <p className="text-gray-700 font-medium">
          {productCount} {productCount === 1 ? 'product' : 'products'} {getDisplayText()}
        </p>
        {(currentCategory || currentSubcategory) && (
          <div className="hidden sm:block h-4 w-px bg-gray-300" />
        )}
      </div>
      
      <div className="flex items-center space-x-3">
        <label className="text-sm font-medium text-gray-700 whitespace-nowrap">
          Sort by:
        </label>
        <div className="relative">
          <select
            value={sortOption}
            onChange={(e) => onSortChange(e.target.value)}
            className="appearance-none bg-white border border-gray-300 rounded-md py-2 pl-3 pr-10 text-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500 min-w-[160px]"
          >
            {sortOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none" />
        </div>
      </div>
    </div>
  );
};

export default ProductSort;